import { IApiMediaWithCropsModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import ImagesModal from '@my-pages/components/ImagesModal.tsx';

interface IBookingObjectImages {
    modalTitle?: string;
    images: IApiMediaWithCropsModel[];
}

const DefaultGridLayout = ({ modalTitle, images }: IBookingObjectImages) => {
    return (
        <section className='rounded-xxl overflow-hidden position-relative'>
            <div className='row mx-n1'>
                <div className='col-md-6 px-1'>
                    <img
                        alt={`Bild på ${images[0].name}`}
                        className='ar-1-1 object-cover'
                        src={`${images[0]?.url}?width=700&height=700`}
                    />
                </div>

                <div className='col-md-6 px-1 d-none d-md-block'>
                    <div
                        className='row mx-n1 position-relative'
                        style={{ rowGap: '0.5rem' }}
                    >
                        {images.map((image, key) => {
                            if (key == 0 || key > 4) return;
                            return (
                                <div
                                    className='col-md-6 position-relative px-1 mb-2x'
                                    key={key}
                                >
                                    <img
                                        alt=''
                                        className='ar-1-1 object-cover'
                                        src={`${image.url}?width=700&height=700`}
                                        key={key}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <ImagesModal
                title={modalTitle}
                images={images}
            />
        </section>
    );
};

const BookingObjectImages = (props: IBookingObjectImages) => {
    const imageGridLayout = () => {
        switch (props.images.length) {
            default:
                return <DefaultGridLayout {...props} />;
        }
    };

    return imageGridLayout();
};

export default BookingObjectImages;
